import { getToken } from '@optimus-web/common';
import { RadioProps } from './Radio';

type Variant = 'checked' | 'unChecked';
type State = 'disabled' | 'default';
type RadioTokenConfig = Record<Variant, Record<State, ReturnType<typeof getToken> | 'inherit'>>;
type Props = Pick<RadioProps, 'checked' | 'disabled'>;

export const getVariantAndState = (props: Props) => {
    const variant: Variant = props?.checked ? 'checked' : 'unChecked';
    const state: State = props?.disabled ? 'disabled' : 'default';
    return { variant, state };
};

export const getBackgroundColor = (props: Props) => {
    const backgroundColorTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryDefault'),
        },
        unChecked: {
            disabled: 'inherit',
            default: 'inherit',
        },
    };

    const { variant, state } = getVariantAndState(props);
    return backgroundColorTokens[variant][state];
};

export const getBorderColor = (props: Props) => {
    const borderColorTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryDefault'),
        },
        unChecked: {
            disabled: getToken('borderDisabled'),
            default: getToken('borderInteractiveInputDefault'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return borderColorTokens[variant][state];
};

export const getBorderColorHover = (props: Props) => {
    const borderColorHoverTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryHover'),
        },
        unChecked: {
            disabled: getToken('borderDisabled'),
            default: getToken('borderInteractiveInputHover'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return borderColorHoverTokens[variant][state];
};

export const getBackgroundColorHover = (props: Props) => {
    const backgroundColorHoverTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryHover'),
        },
        unChecked: {
            disabled: 'inherit',
            default: getToken('backgroundInteractiveNeutralSubtleHover'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return backgroundColorHoverTokens[variant][state];
};

export const getBorderColorActive = (props: Props) => {
    const borderColorActiveTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryActive'),
        },
        unChecked: {
            disabled: getToken('borderDisabled'),
            default: getToken('borderInteractiveInputActive'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return borderColorActiveTokens[variant][state];
};

export const getBackgroundColorActive = (props: Props) => {
    const backgroundColorActiveTokens: RadioTokenConfig = {
        checked: {
            disabled: getToken('backgroundDisabled'),
            default: getToken('backgroundInteractivePrimaryActive'),
        },
        unChecked: {
            disabled: 'inherit',
            default: getToken('backgroundInteractiveNeutralSubtleActive'),
        },
    };

    const { variant, state } = getVariantAndState(props);
    return backgroundColorActiveTokens[variant][state];
};
